import { Link, Stack } from 'expo-router';
import { StyleSheet, Text, View } from 'react-native';
import { C, F } from '@/constants/theme';

export default function NotFoundScreen() {
  return (
    <>
      <Stack.Screen options={{ title: 'Ups' }} />
      <View style={s.container}>
        <Text style={s.title}>Esta pantalla no existe.</Text>
        <Link href="/" style={s.link}>
          <Text style={s.linkText}>Volver a Pulse</Text>
        </Link>
      </View>
    </>
  );
}

const s = StyleSheet.create({
  container: { flex: 1, alignItems: 'center', justifyContent: 'center', padding: 20, backgroundColor: C.bg },
  title: { fontFamily: F.uiSemi, fontSize: 18, color: C.ink },
  link: { marginTop: 15, paddingVertical: 15 },
  linkText: { fontFamily: F.uiMed, fontSize: 14, color: C.aqua },
});
